

















import Vue from "vue";
import Component from "vue-class-component";
import Page from "@/components/layout/page.vue";
import MoveDesksModal from "@/components/modals/move-desks.vue";
import { Desk, Zone } from "@/swagger/models";
import { deskService } from "@/services/desk";
import { Committable, WrapService } from "@/plugins/committable";
import CommitResetBar from "@/components/data/commit-reset-bar.vue";
import Card from "@/components/layout/card.vue";
import PageHeader from "@/components/navigation/page-header.vue";
import TabsDesk from "@/views/desk/desk-tabs.vue";
import { zoneService } from "@/services/zone";
import ReservationsTable from "@/components/tables/reservations/reservations-table.vue";
import {
    ReservationsTableInitialFilters,
    ReservationTableFilters,
} from "@/components/tables/reservations/reservation-table-types";

// See https://github.com/kaorun343/vue-property-decorator for all options
// Todo: move to components folder

@Component({
    name: "desks",
    components: { ReservationsTable, TabsDesk, PageHeader, Card, CommitResetBar, MoveDesksModal, Page },
})
export default class Desks extends Vue {
    desk: Desk = null;

    async created() {
        this.desk = await deskService.get(parseInt(this.$route.params.deskId));
    }

    get filters(): ReservationsTableInitialFilters {
        return {
            deskId: parseInt(this.$route.params.deskId),
            customerId: parseInt(this.$route.params.customerId),
        };
    }
}
